import styled from 'styled-components';

export const CaptchaSectionStyle = styled.div`
  display: inline-block;
  .captchaStyle {
    width: 100%;
    max-width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
  }
  .captchaStyle iframe {
    transform: scale(0.6);
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .error-message {
    font-size: 10px;
  }
`;
